import { TabBar } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { ClassDivisionTables } from '../../../components/Classes/Tables/ClassDivisionTables';
import { Page } from '../../../components/Page/Page';
import { usePermissionChecker } from '../../../hooks/usePermissionChecker';
import { SettingsClassesContent } from './content/SettingsClassesContent';

export const SetupClassesAndDivisions = () => {
  const { t } = useTranslation();

  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()}>
      <TabBar
        variant='large'
        tabs={[
          {
            trigger: t('classes.title', { count: 2 }),
            id: 'classes',
            content: <SettingsClassesContent />,
          },
          {
            trigger: t('divisions.title', { count: 2 }),
            id: 'divisions',
            content: <ClassDivisionTables />,
          },
        ]}
      />
    </Page>
  );
};
